exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pc .profile-dealers .profile-dealer {\n  margin-top: 30px;\n  margin-bottom: 15px;\n}\n\n.pc .profile-dealers .profile-dealer h4 {\n  margin: 0;\n}\n\n.pc .profile-dealers .profile-dealer button {\n  margin-top: 15px;\n}\n\n", ""]);

// exports
